import { Info } from "lucide-react"
import { Button } from "./ui/button"
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover"

interface FieldInfoIconProps {
	iconType: string
	infoText: string
}

export default function FieldInfoIcon({
	iconType,
	infoText,
}: FieldInfoIconProps) {
	if (iconType === "ON_HOVER") {
		return (
			<div className="group relative inline-block">
				<Button
					variant="ghost"
					size="icon"
					className="h-fit w-fit !px-2 !py-2"
					type="button"
				>
					<Info className="size-4" />
				</Button>
				{infoText.length > 0 && (
					<div className="bg-muted pointer-events-none absolute left-10 top-0 z-50 w-max rounded-xl px-4 py-2 text-sm opacity-0 transition-opacity duration-300 group-hover:opacity-100">
						{infoText}
					</div>
				)}
			</div>
		)
	} else {
		return (
			<Popover>
				<PopoverTrigger asChild>
					<Button
						variant="ghost"
						size="icon"
						className="h-fit w-fit !px-2 !py-2"
						type="button"
					>
						<Info className="size-4" />
					</Button>
				</PopoverTrigger>
				<PopoverContent
					side="right"
					className="bg-muted w-fit rounded-xl border-none px-4 py-2 text-sm"
				>
					<p>{infoText}</p>
				</PopoverContent>
			</Popover>
		)
	}
}
